import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiAction } from "../../../api/ApiAction";
import { endpoints } from "../../../api/endpoints";
import { IDestinationCity } from "../../../api/types/directory/IDestinationCity";
import { AppDispatch } from "../../appDispatch";
import { RootState } from "../../rootState";
import { IAssociateParams } from "./types/IAssociateParams";

export const fetchAssociateDestinationCities = createAsyncThunk<
  IDestinationCity[],
  IAssociateParams,
  { state: RootState; dispatch: AppDispatch }
>("associate/fetchDestinationCities", async (params, thunkAPI) => {
  const result = await endpoints.directory.get(
    {
      action: ApiAction.getDestinationCities,
      operator: params.operator,
      country: params.country,
    },
    thunkAPI.signal,
  );

  return result as IDestinationCity[];
});
